import { FC } from 'react';
import { styled, Container, Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from './vertical/header/Header';
import SidebarV2 from './vertical/sidebar/SidebarV2';
import Navigation from './horizontal/navbar/Navigation';
import HorizontalHeader from './horizontal/header/Header';
import { RootState, useAppSelector } from '@shared/store';
import { StartStopProvider } from '@features/Admin/Campaign/contexts/startstop.provider';
import { ToastContainer } from 'react-toastify';
import { tss } from 'tss-react/mui';

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
}));

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  zIndex: 1,
  width: '100%',
  backgroundColor: 'transparent',
  overflow: 'auto',
  height: '100vh',
}));

const useStyles = tss.create(({ theme }) => ({
  toast: {
    '.Toastify__toast': {
      width: 'max-content',
    },
    '.Toastify__toast, .Toastify__toast--rtl': {
      border: `1px solid ${theme.palette.extendedGrey?.light}`,
      borderRadius: '12px',
      boxShadow: '0px 1px 2px 1px #1018280D',
    },
    '.Toastify__progress-bar--success': {
      backgroundColor: theme.palette.success.light,
    },
    '.Toastify__progress-bar--error': {
      backgroundColor: theme.palette.error.light,
    },
  },
}));

export const FullLayout: FC = () => {
  const customizer = useAppSelector((state: RootState) => state.customizer);
  const { classes } = useStyles();
  return (
    <StartStopProvider>
      <MainWrapper>
        {/* ------------------------------------------- */}
        {/* Sidebar */}
        {/* ------------------------------------------- */}
        {customizer.isHorizontal ? '' : <SidebarV2 />}
        {/* ------------------------------------------- */}
        {/* Main Wrapper */}
        {/* ------------------------------------------- */}
        <PageWrapper
          className="page-wrapper"
          sx={{
            ...(customizer.isCollapse && { ml: `${customizer.MiniSidebarWidth}px` }),
          }}>
          {/* ------------------------------------------- */}
          {/* Header */}
          {/* ------------------------------------------- */}
          {customizer.isHorizontal ? <HorizontalHeader /> : <Header />}
          {/* PageContent */}
          {customizer.isHorizontal ? <Navigation /> : ''}
          <Container
            sx={{
              height: '100%',
              maxWidth: customizer.isLayout === 'boxed' ? 'lg' : '100%!important',
            }}>
            {/* ------------------------------------------- */}
            {/* PageContent */}
            {/* ------------------------------------------- */}

            <Box
              sx={{
                minHeight: 'calc(100vh - 170px)',
                height: '100%',
                position: 'relative',
                '> div': { height: '100%' },
              }}>
              <Outlet />
            </Box>

            {/* ------------------------------------------- */}
            {/* End Page */}
            {/* ------------------------------------------- */}
          </Container>
          {/* <Customizer /> */}
        </PageWrapper>
      </MainWrapper>
      <ToastContainer
        className={classes.toast}
        position="bottom-right"
        rtl={customizer.activeDir === 'rtl'}
        theme={customizer.activeMode}
      />
    </StartStopProvider>
  );
};
